import { SET_OUTAGE_BANNER, CLOSE_OUTAGE_BANNER } from 'AppSrc/core/components/outage-banner/outage-constant';
// Set outage banner at the login
const setOutageBanner = (outage) => ({
  type: SET_OUTAGE_BANNER,
  payload: {
    outage,
  },
});
// when user Clicks on Ok in banner
const closeOutageBanner = (outage) => ({
  type: CLOSE_OUTAGE_BANNER,
  payload: {
    outage,
  },
});

export {
  setOutageBanner,
  closeOutageBanner,
};
